import React, { cloneElement, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PrimaryButton from '../../../ui/PrimaryButton';
import ActionButton, { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import * as XCol from "../../../framework.core/XExportColumn";
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useSystemSettings from '../../../hooks/useSystemSettings';
import BicInfoAreaHistory from '../../common/BicInfoAreaHistory';
import lockRed from '../../../img/lock_red.png';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import { NavigationType, openNewPage } from '../../../util/navigationHelpers';
import { invoiceList, TableColumn, TableSettings } from '../../../tableSettings';
import constants from '../../../constants';
import ApplicationContext from '../../../ApplicationContext';
import {
  CurrencyAmountRenderer, DateRenderer, DateTimeRenderer, NullableCheckboxIconRenderer,
  TextAlignLeftRenderer, TextAlignRightRenderer, TextRenderer,
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import AbstractListView, {
  DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer
} from "../../common/AbstractListView";
import { Search } from '../../../filtering';
import {
  getJobNameFromInvBillCrDbJobType,
  getOpTypeConstant,
  JobNames
} from '../../../framework.core/JobNames';
import { InvoiceListItem } from '../../../fms.data/models/InvoiceListItem';
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BicTypeFilterRenderer, DraftFilterRenderer, PeriodRenderer, RecognizedFilterRenderer, RecognizedRenderer, StatusNotUseFileLockedRenderer, VoidFilterRenderer } from '../../common/commonListRenderers';
import Edi310 from '../../reports/Edi310';
import Edi310Batch from '../../reports/Edi310Batch';
import { FmsSecTask } from '../../../fms.core/constants';
import CustomerBalanceDetails from '../../reports/AccountBalance';
import { nowDate } from '../../../dateUtils';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, getSecBySecTask } from '../../../util';
import CopyInvoice from '../common/CopyInvoice';
import { getFmsGlobal } from '../../../globals';
import BatchPrint from '../../reports/BatchPrint';
import { DocumentType } from "../../../framework.core/DocumentType";
import { FormType, SecType } from '../../../fms.enum';
import HistoryView from '../../reports/HistoryView';
import useReportViewer from '../../../hooks/useReportViewer';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { useJournal } from '../general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import CheckBoxUncontrolled from '../../../ui/CheckBoxUncontrolled';
import { FmsSecCntr } from '../../../fms.core/constants/FmsSecCntr';
import { CurrencyAmountValue, nullableCheckBoxValue } from '../../common/commonExportFormat';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;


  return (
    //<div className="ifms-table-default" style={{ width: '100%', minHeight: '22px', cursor: 'pointer' }} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function DraftRenderer({ cell }: any) {
  if (cell && cell.value) {
    return (
      <div data-tooltip={'Draft'} className="ifms-table-default">
        <span style={{ color: 'green' }}>V</span>
      </div>
    );
  }

  return <div className="ifms-table-default"></div>;
}

function VoidRenderer({ cell }: any) {
  if (cell && cell.value === 1) {
    return (
      <div data-tooltip={'Void'} className="ifms-table-default">
        <span style={{ color: 'red' }}>V</span>
      </div>
    );
  }

  return <div className="ifms-table-default"></div>;
}


function ConfirmedRenderer({ value, row }: any) {
  
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const suntekSettings = useSuntekSettings();

  if(jobListContext.opType === constants.opTypes.warehousing){
    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.WHInvoice] : null;
    if (!secCont) {
      secCont = [
        { secCntr: FmsSecCntr.InvGivCredit, contName: 'cmdNew10' },
        { secCntr: FmsSecCntr.InvCancelCredit, contName: 'cmdNew12' },
        { secCntr: FmsSecCntr.WHInvConfirmed, contName: 'chkConfirmed' },
        { secCntr: FmsSecCntr.WHInvDraft, contName: 'chkDraft' }
    ];
      appContext.setSecurityControls(JobNames.WHInvoice, secCont);
    }
  }else{
    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.Invoice] : null;
    if (!secCont) {
      secCont = [
        { secCntr: FmsSecCntr.InvGivCredit, contName: 'cmdNew10' },
        { secCntr: FmsSecCntr.InvCancelCredit, contName: 'cmdNew12' },
        { secCntr: FmsSecCntr.InvConfirmed, contName: 'chkConfirmed' },
        { secCntr: FmsSecCntr.InvDraft, contName: 'chkDraft' }
    ];
      appContext.setSecurityControls(JobNames.Invoice, secCont);
    }
  }


  async function updateConfirmed(newValue: boolean) {
    await appContext.api.setInvoiceConfirmed(row.original.id, newValue);
    row.original.confirmed = newValue;
    jobListContext.updateDataRow(row.original);

  }

  function findClickedCell(element: Element): Element | null {
    for (let i = 0; i < 6; ++i) {
      if (!element) {
        break;
      }
      if (Array.from(element.classList).some(className => className.startsWith('row-'))) {
        return element;
      }
      element = element.parentNode as Element;
    }
    return null;
  }

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <CheckBoxUncontrolled
        key={row.original.id}
        initialValue={Boolean(value)}
        onChange={updateConfirmed}
        disabled={appContext.getControlDisableStatus(jobListContext.opType === constants.opTypes.warehousing?JobNames.WHInvoice:JobNames.Invoice, 'chkConfirmed', FormType.ModeEdit)}
        allowOnChange={async (e) => {
          if (!e) return false;

          e?.stopPropagation();

          const element = findClickedCell(e.currentTarget);
          if (!element) {
            await showGlobalOkDialog(<p>Cannot find hover element</p>, false, null, 'warning');
            return false;
          }

          const classes = element.classList;
          const mouseOverRowIndex = Array.from(classes).find(className => className.includes('row-'))?.match(/\d+$/)?.[0];

          if (!mouseOverRowIndex || !jobListContext.data) {
            await showGlobalOkDialog(<p>Cannot find hover data</p>, false, null, 'warning');
            return false;
          }

          const rowData = jobListContext.data[parseInt(mouseOverRowIndex)];
          if (rowData.void > 0) {
            await showGlobalOkDialog(<p>This Invoice has been voided.</p>);
            return false;
          } else if (rowData.paidAmount !== 0) {
            await showGlobalOkDialog(<p>This Invoice has been already paid.</p>);
            return false;
          } else if (rowData.draft) {
            await showGlobalOkDialog(<p>This Invoice is Draft.</p>);
            return false;
          } else {
            return true;
          }
        }} />
    </div>
  );
}


function formatData(data: Array<InvoiceListItem>) {
  return data.map((d: InvoiceListItem) => ({
    ...d,
    status: d.draft ? '' : d.status
  }));
}

function useInvoiceOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToList(jobName: JobNames, jobId: number, refNo: string, hblNo: string) {
    // const blType = isMasterJob(jobName) ? 'mbl' : 'hbl';
    let blType = '';
    let columnLabel = '';
    let columnIdEx = null;
    let textEx = null;
    switch(jobName) {
      case JobNames.OIMbl:
        blType = 'mbl';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.OIHbl:
        blType = 'hbl';
        columnLabel = 'HBL #';
        columnIdEx = 'hblNo';
        textEx = hblNo;
        break;
      case JobNames.OEMbl:
        blType = 'oeMbl';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.OEHbl:
        blType = 'oeHbl';
        columnLabel = 'HBL #';
        columnIdEx = 'hblNo';
        textEx = hblNo;
        break;
      case JobNames.AIMbl:
        blType = 'aiMawb';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.AIHbl:
        blType = 'aiHawb';
        columnLabel = 'HAWB #';
        columnIdEx = 'hawbNo';
        textEx = hblNo;
        break;
      case JobNames.AEMbl:
        blType = 'aeMawb';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.AEHbl:
        blType = 'aeHawb';
        columnLabel = 'HAWB #';
        columnIdEx = 'hawbNo';
        textEx = hblNo;
        break;
      case JobNames.OtherOP:
        blType = 'otherShipment';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.WHRcv:
        blType = 'whReceiving';
        columnLabel = 'Receiving ID';
        columnIdEx = 'receiveNo';
        textEx = refNo;
        break;
      case JobNames.WHShip:
        blType = 'whShipping';
        columnLabel = 'Shipping ID';
        columnIdEx = 'shipNo';
        textEx = refNo;
        break;
      case JobNames.BTLoadPlan:
        blType = 'btLoadPlan';
        columnLabel = 'Load #';
        columnIdEx = 'loadNo';
        textEx = refNo;
        break;
      case JobNames.BTOrder:
        blType = 'btOrder';
        columnLabel = 'PRO #';
        columnIdEx = 'orderNo';
        textEx = refNo;
        break;

    }
    const opType = getOpTypeConstant(jobName);
    jobListContext.setFilterForScreenExternally(`/common/joblistview/${blType}/${opType}`, 'id', columnLabel, jobId.toString(), 'update', false, true, null, columnIdEx, textEx, false, true);
    openNewPage(history, `/common/joblistview/${blType}/${opType}`, NavigationType.newPage);
  }

  function switchToParentFor(invoice: InvoiceListItem) {
    if (!invoice) {
      return;
    }
    if(invoice.jobType === '') return;

    // if (invoice.type === JobNames.OIMbl) {
    //   switchToMbl(invoice.parentNo ?? '');
    // }
    // if (invoice.type === JobNames.OIHbl) {
    //   switchToHbl(invoice.refNo ?? '');
    // }
    switchToList(getJobNameFromInvBillCrDbJobType(invoice.jobType), invoice.tbId, invoice.referenceNo, invoice.hblNo);
  }

  return { switchToParentFor };
}

function useSelectedInvoiceOperations() {
  const fmsGlobal = getFmsGlobal();
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const { switchToParentFor } = useInvoiceOperations();

  const selectedElement = jobListContext.selectedElement as InvoiceListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/periodInvoice/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }
    openNewPage(history, '/accounting/periodInvoice/add', NavigationType.newPage);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    if (!selectedElement.jobType && selectedElement.period !== "P") {
      //await showGlobalOkDialog(<p>Operation currently not implemented for this type</p>);
      return;
    }

    const id = selectedElement.id;

    let viewUrl = `/accounting/invoice/view/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${id}`;
    if (!selectedElement.jobType && selectedElement.period === "P") viewUrl = `/accounting/periodInvoice/view/${id}`;
    let editUrl = `/accounting/invoice/edit/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${id}`;
    if (!selectedElement.jobType && selectedElement.period === "P") editUrl = `/accounting/periodInvoice/edit/${id}`;
    
    // Edit 창은 하나만 열리도록 수정
    // if (jobListContext.hasOpenedScreenInAnyOperationStartingWithUrlWithoutMe(editUrl.substring(0, editUrl.indexOf('/edit')+5), editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    if (!selectedElement.jobType && selectedElement.period !== "P") {
      //await showGlobalOkDialog(<p>Operation currently not implemented for this type</p>);
      return;
    }

    const id = selectedElement.id;

    let viewUrl = `/accounting/invoice/view/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${id}`;
    if (!selectedElement.jobType && selectedElement.period === "P") viewUrl = `/accounting/periodInvoice/view/${id}`;
    let editUrl = `/accounting/invoice/edit/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${id}`;
    if (!selectedElement.jobType && selectedElement.period === "P") editUrl = `/accounting/periodInvoice/edit/${id}`;

    const listSec = findSecurityTask(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHInvoice : FmsSecTask.AcctInvoiceList));
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  function switchToParent() {
    const selectedElement = jobListContext.selectedElement as InvoiceListItem;
    switchToParentFor(selectedElement);
  }

  async function deleteItem() {
    if (!selectedElement) {
      await showGlobalOkDialog('Cannot delete!',false,null,'warning');
      return;
    }

    if (!selectedElement.jobType && selectedElement.period === "P") {
      if (
        jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/periodInvoice/edit/${selectedElement.id}`) || 
        jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/periodInvoice/view/${selectedElement.id}`)
      ) {
        await showGlobalOkDialog('Need to close Invoice first', false, null, "warning");
        return;
      }
    }
    else {
      if (
        jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/invoice/edit/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${selectedElement.id}`) || 
        jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/invoice/view/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${selectedElement.id}`)
      ) {
        await showGlobalOkDialog('Need to close Invoice first', false, null, "warning");
        return;
      }
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.Invoice, { id: selectedElement.id, opAcctBlockAfterClosed: fmsGlobal?.OPAcctBlockAfterClosed??false });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false,null,'warning');
      }
    }
  }

  async function viewPaymentHistory() {
    if (!selectedElement) {
      return;
    }

    const jobId = selectedElement.id;
    const jobName = JobNames.Invoice;
    const jobType = selectedElement.jobType

    const viewUrl = `/accounting/acPaymentHistoryView/${jobName}/${jobId}/${getJobNameFromInvBillCrDbJobType(jobType)}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  return { create, edit, view, switchToParent, deleteItem, viewPaymentHistory };
}

function RightClickMenu({ dismiss }: { dismiss: VoidFunction }) {
  const { create, edit, view, deleteItem, switchToParent } = useSelectedInvoiceOperations();
  const jobListContext = useContext(JobListViewContext);
  
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHInvoice : FmsSecTask.AcctInvoiceList));
  const selectedElement = jobListContext.selectedElement as InvoiceListItem;
  // const isDraft =  jobListContext.selectedElement.draft;

  const items = [ 
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd || jobListContext.opType !== 'warehousing'},
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: jobListContext.opType === constants.opTypes.warehousing ? 'Go to W/H List' : (selectedElement.jobType === 'ODM'? 'Go to Manifest List' : 'Go to Load List'), 
      shortcut: 'F6', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) => ({
    label: <ToolboxMenuItem name="invoice-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item: IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();      
        break;
      case 1:  
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        switchToParent();
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as InvoiceListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if ((!suntekSettings.general?.allowViewJournalBillings && !userId.startsWith('@')) || jobListContext.opType !== constants.opTypes.warehousing) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.Invoice, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}

function InvoiceListCommands() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem | null>(null);

  const selectedElement = jobListContext.selectedElement as InvoiceListItem;

  const { edit, view, deleteItem, viewPaymentHistory } = useSelectedInvoiceOperations();

  const hasSelectedRow = !!selectedElement;

  const appContext = useContext(ApplicationContext);
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();

  const listSec = findSecurityTask(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHInvoice : FmsSecTask.AcctInvoiceList));
  const hasSecCp = getSecBySecTask(appContext, FmsSecTask.AcctCustPayment, SecType.Add);
  const hasSecBp = getSecBySecTask(appContext, FmsSecTask.AcctBillPayment, SecType.Add);

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function print() {
    if (!selectedElement) {
      return;
    }

    let puInvoice: boolean = false;

    if (appContext.suntekSettings?.company?.companyId === "AECL002209") {
      const doConfirm = await showGlobalYesNoDialog(
        <div>
          <h3>Confirm to Print?</h3>
          <p>Do you want to print P/U Invoice?</p>
        </div>
      ,false, 0, true);
      if (doConfirm) {
        puInvoice = true;
      }
    }

    if (!puInvoice && appContext.suntekSettings?.company?.country === "MEXICO" && appContext.suntekSettings?.company?.companyId === "PEOP002103") {
      // Batch Invoice
      setSelectedPopupMenuItem({ label: 'Invoice Batch Print', popupComponent: <BatchPrint selectedElement={selectedElement} documentType={DocumentType.InvoiceS} jobName={JobNames.RptInvoiceS} /> });
    } else {
      const args = await getSelectedSubMenuArgs(puInvoice ? FmsSubMenu.PuInvoice : FmsSubMenu.Invoice, JobNames.Invoice, selectedElement, appContext, null, null);
      if (args) {
        viewReport(args, "", true);
      }
    }
  }

  async function onCustomerBillAction(item: ActionButtonItem) {
    let link = '';
    switch (item.index) {
      case 0:
        link = `/accounting/acCustomerPayment/add`;
        break;
      case 1:
        link = `/accounting/acBillPayment/add`;
        break;
      case 2:
        jobListContext.setFilterForScreenExternally('/common/joblistview/acCustomerPayment/accounting',
          'invoiceNo', 'Billings', selectedElement.invoiceNo, 'updated', false, true, null);
        openNewPage(history, '/common/joblistview/acCustomerPayment/accounting', NavigationType.newPage);
        return;
      case 3:

        jobListContext.setFilterForScreenExternally('/common/joblistview/acBillPayment/accounting',
          'invoiceNo', 'Billings', selectedElement.checkNo, 'updated', false, true, null);
        openNewPage(history, '/common/joblistview/acBillPayment/accounting', NavigationType.newPage);
        return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(link)) {
      await showGlobalOkDialog(<p>Payment New Operation is already in progress.</p>);
      return;
    }

    openNewPage(history, `${link}/${selectedElement.invoiceTo}`, NavigationType.newPage);
  }

  function onHistoryBtnAction(item: ActionButtonItem) {
    switch (item.index) {
      case 0:
        viewPaymentHistory();
        break;
      case 1:
        setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1200, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType === '' ? 'WHP' : selectedElement.jobType} jobName={JobNames.Invoice} /> });
        break;
      // case 2:
      //   setSelectedPopupMenuItem({ label: 'Delete History (Invoice)', popupWidth: 920, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType === '' ? 'WHP' : selectedElement.jobType} jobName={JobNames.Invoice} viewDeleteHistory={true} /> })
      //   return;
    }
  }

  async function onPrintAction(item: ActionButtonItem){
    if(item.index === 0) print();
    else setSelectedPopupMenuItem({ label: 'Invoice Batch Print', popupComponent: <BatchPrint selectedElement={selectedElement} documentType={DocumentType.InvoiceS} jobName={JobNames.RptInvoiceS} /> });
  }

  async function copyInvoice() {
    if (selectedElement.draft) {
      await showGlobalOkDialog(<p>The Draft Invoice cannot be copied.</p>,false,null,'warning');
      return;
    }
    setSelectedPopupMenuItem({
      label:'Select a target B/L to be linked',
      popupWidth: 450,
      popupComponent:
        <CopyInvoice
          jobId={selectedElement.id}
          jobName={JobNames.Invoice}
          srcJobName={getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}
          srcJobId={selectedElement.tbId}
          onPopupClose={onPopupClose}
        />
    });
  }

  async function customerBalance() {
    if (selectedElement.invoiceTo <= 0) {
      await showGlobalOkDialog(<p>You didn't enter Invoice To.</p>,false,null,'warning');
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <CustomerBalanceDetails
          jobId={selectedElement.id}
          jobName={jobListContext.opType === constants.opTypes.warehousing ? JobNames.WHInvoice : JobNames.Invoice}
          onPopupClose={onPopupClose}
          //toDate={invoice.postDate || ''}
          toDate={nowDate()}
          comId={selectedElement.invoiceTo}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.invoiceToName}
        />
    });
  }

  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && listSec?.grantAdd;
  //const disablePrint = hasSelectedRow && selectedElement.draft;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        {/* <chuck date="2025-02-13" Git="3.3-2414" desc="Hide the Add button temporary" /> */}
        {/* {(jobListContext.opType === constants.opTypes.warehousing) &&
          <><UniqueLinkButton name='invoice-list-add-button' display="primary" size="regular" link="/accounting/periodInvoice/add" disabled={!canBeAdd} label="New" />&nbsp;</>
        } */}
        <PrimaryButton name='invoice-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='invoice-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='invoice-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteItem}>Delete</PrimaryButton>&nbsp;
        {(jobListContext.opType !== constants.opTypes.warehousing && jobListContext.opType !== constants.opTypes.order && jobListContext.opType !== constants.opTypes.load) && 
          <>
            <PrimaryButton
              name='invoice-list-copy-button'
              size="regular"
              disabled={!canBeCopied}
              onClick={copyInvoice}>
              Copy
            </PrimaryButton>
          </>
        }
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>

      {(jobListContext.opType === constants.opTypes.warehousing)
      &&<>
      
        <ActionButton
              name='invoice-list-print-button' 
              type="primary"
              items={[
                { label: 'Print', separator: false, index: 0, name: "invoice-list-sub-print-button" },
                { label: 'Batch Print', separator: false, index: 1, name: "invoice-list-sub-batchprint-button" },
              ]}
              onItemSelected={onPrintAction}
            >
              Print
            </ActionButton>&nbsp;

            {(hasSecCp || hasSecBp) &&
              <>
                <ActionButton
                  name='invoice-list-pay-button'
                  type="primary"
                  items={[
                    { label: 'New Customer Pay', separator: false, index: 0, hidden: !hasSecCp, name: "invoice-list-sub-customerpay-button" },
                    { label: 'New Bill Pay', separator: true, index: 1, hidden: !hasSecBp, name: "invoice-list-sub-billpay-button" },
                    { label: 'Customer Pay List', separator: false, index: 2, hidden: !hasSecCp, name: "invoice-list-sub-customerpayList-button" },
                    { label: 'Bill Pay List', separator: false, index: 3, hidden: !hasSecBp, name: "invoice-list-sub-billpayList-button" },

                  ]}
                  onItemSelected={onCustomerBillAction}
                >
                  Pay
                </ActionButton>&nbsp;
              </>
            }
            <>
              <ActionButton
                name='invoice-list-viewhistory-button'
                type="primary"
                items={[
                  { label: 'Payment History', separator: false, index: 0, hidden: !hasSelectedRow, name: "invoice-list-payment-button" },
                  { label: 'View History', separator: false, index: 1, hidden: !hasSelectedRow, name: "invoice-list-history-button" },
                ]}
                onItemSelected={onHistoryBtnAction}
              >
                View History
              </ActionButton>&nbsp;
            </>
            {/* <PrimaryButton size="regular" disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'Payment History', popupWidth: 1050, popupComponent: <PaymentHistory jobId={selectedElement.id} jobName={JobNames.Invoice} /> })}>Payment History</PrimaryButton>&nbsp; 
            <PrimaryButton name='invoice-list-payhistory-button' disabled={!hasSelectedRow} size="regular" onClick={viewPaymentHistory}>Payment History</PrimaryButton>&nbsp;
            <PrimaryButton name='invoice-list-viewhistory-button' size="regular" disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1200, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType === '' ? 'WHP' : selectedElement.jobType} jobName={JobNames.Invoice} viewDeleteHistory={false} /> })}>View History</PrimaryButton>&nbsp;*/}
          </>
      }
        
        {/* { appContext.suntekSettings?.edi?.enableEDI310 && jobListContext.opType !== constants.opTypes.warehousing && jobListContext.opType !== constants.opTypes.order && jobListContext.opType !== constants.opTypes.load &&
        <>
          <ActionButton
            name='invoice-list-edi-button' 
            type="primary"
            items={[
              { label: 'EDI 310', separator: false, popupComponent: <Edi310 selectedElement={selectedElement} onPopupClose={onPopupClose}/>, popupWidth: 760 },
              { label: 'EDI 310 Batch', separator: false, popupComponent: <Edi310Batch selectedElement={selectedElement} onPopupClose={onPopupClose}/>, popupWidth: 760 },
            ]}
            onItemSelected={(event) => {
              if (!hasSelectedRow) {
                return;
              }

              if (!['OIH','AIH'].includes(selectedElement.jobType)) {
                showGlobalOkDialog(`It is not available for the selected operation type (${selectedElement.jobType}).`,false,null,'warning');
                return;
              }

              setSelectedPopupMenuItem(event);
            }}
          >
            EDI
          </ActionButton>&nbsp;
          </>
        } */}
        {jobListContext.opType !== constants.opTypes.warehousing && (
          <>
            <PrimaryButton
              name='billings-invoice-list-print-button'
              size="regular"
              disabled={!hasSelectedRow}
              onClick={print}>
              Print
            </PrimaryButton>&nbsp;
          </>
        )}
        <PrimaryButton
          name='invoice-list-balance-button' 
          size="regular"
          disabled={!hasSelectedRow}
          onClick={customerBalance}>
          Balance
        </PrimaryButton>
      </div>

      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
    </div>
  );
}


function InvoiceListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}


function InvoiceListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({ onFunction: onFunctionKey });

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const listSec = findSecurityTask(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHInvoice : FmsSecTask.AcctInvoiceList));
  const systemSettings = useSystemSettings();

  const { create, edit, view, switchToParent } = useSelectedInvoiceOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
    if (!unprocessedFkey) {
      return;
    }

    doProcessFkey();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToParent();
    }else if (unprocessedFkey === "F2" && jobListContext.opType === 'warehousing') {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  /**
   * 
   * @param param { jobName, jobId, appContext, jobListContext } 
   * @returns 
   */
  async function loadInvoiceHistory(param: any) {
    //const apiResult = await appContext.api.getOceanImportInvoiceHistory(id);
    const apiResult = await appContext.api.getAcctHistory(param.jobName, param.jobId, (jobListContext.selectedElement as InvoiceListItem).jobType, false);
    if (!apiResult || !apiResult.success) {
      return null;
    }

    return <BicInfoAreaHistory context="invoice" historyData={apiResult.result} primaryCurrency={systemSettings?.primaryCurrency ?? ''} />
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.Invoice}
      jobId={(jobListContext.selectedElement as InvoiceListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: '',
          contentLoader: loadInvoiceHistory,
          params: { appContext, jobListContext }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

/**
 * Concrete implementation for INVOICE (OI) List screen
 *
 * @class InvoiceListView
 * @extends {AbstractListView}
 */
class InvoiceListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;
    let listType: JobNames.Invoice | JobNames.WHInvoice | JobNames.GInvo = JobNames.Invoice ;
    if (opType === constants.opTypes.warehousing) {
      listType = JobNames.WHInvoice;
    }

    const tsettings = invoiceList;
    const cols = InvoiceListItem.getExportCollection(listType, useBranch, useVat);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  getCustomFilterRenderers(opType?: string | undefined): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'jobType',
        renderer: (props: any) => <BicTypeFilterRenderer opType={opType} acctType={'INV'} {...props} />,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      //{
      //  accessor: 'draft',
      //  renderer: DraftFilterRenderer,
      //  searchValueExtractor: (v: any | null | undefined) => v === 'D' ? true : false,
      //},
      // {
      //   accessor: 'void',
      //   renderer: VoidFilterRenderer,
      //   searchValueExtractor: (v: any | null | undefined) => v === 'V' ? 1 : 0,
      // },
      {
        accessor: 'confirmed',
        renderer: undefined,
        searchValueExtractor: (v: any | null | undefined) => v.value !== undefined ? v.value : v,
      },
    ];
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;
    let listType: JobNames.Invoice | JobNames.WHInvoice | JobNames.GInvo = JobNames.Invoice;
    if (opType === constants.opTypes.warehousing) {
      listType = JobNames.WHInvoice;
    }

    return InvoiceListItem.getExportCollection(listType, useBranch, useVat).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === "draft") {
        // colRenderer.Cell = DraftRenderer;
        colRenderer.Cell = NullableCheckboxIconRenderer;
      }
      else if (x.dataIndex === 'recognized') {
        colRenderer.Cell = RecognizedRenderer;
      }
      // else if (x.dataIndex === "void") {
      //   colRenderer.Cell = VoidRenderer;
      // }
      else if (x.dataIndex === "period") {
        colRenderer.Cell = PeriodRenderer;
      }
      else if (x.dataIndex === "confirmed") {
        colRenderer.Cell = ConfirmedRenderer;
      }
      else if (x.dataIndex === "amount" || x.dataIndex === "paidAmount" || x.dataIndex === "balance" || x.dataIndex === "cAmount" || x.dataIndex === "dutyAmount"|| x.dataIndex === "vatAmount") {
        colRenderer.Cell = props => <CurrencyAmountRenderer currencyAccessor={(x: any) => x.currency} {...props} />;
      }
      else if (x.dataIndex === "referenceNo" || x.dataIndex === "hblNo") {
        colRenderer.Cell = TextAlignLeftRenderer;
      }
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'amount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['amount']) } });
    colRenderer.push({ accessor: 'paidAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['paidAmount']) } });
    colRenderer.push({ accessor: 'balance', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['balance']) } });
    colRenderer.push({ accessor: 'cAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['cAmount']) } });
    colRenderer.push({ accessor: 'dutyAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['dutyAmount']) } });
    colRenderer.push({ accessor: 'vatAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['vatAmount']) } });
    colRenderer.push({ accessor: 'draft', changedValue: (value: any) => { return nullableCheckBoxValue(value['draft'])}});
    colRenderer.push({ accessor: 'confirmed', changedValue: (value: any) => { return nullableCheckBoxValue(value['confirmed'])}});
    return colRenderer;
  }

  /**
   * 
   * @param api 
   * @param search 
   * @param opType
   * @returns 
   */
  async fetchAndFormatData(api: any, search: Search, opType: string | undefined): Promise<DataFetchResult> {
    const searchModel = InvoiceListItem.calculateSearchParameters(search, InvoiceListItem.MapSearchFields, ['void']);
    if (opType === constants.opTypes.oceanImport) searchModel.extraWhere = JobNames.OceanImport;
    else if (opType === constants.opTypes.oceanExport) searchModel.extraWhere = JobNames.OceanExport;
    else if (opType === constants.opTypes.airImport) searchModel.extraWhere = JobNames.AirImport;
    else if (opType === constants.opTypes.airExport) searchModel.extraWhere = JobNames.AirExport;
    else if (opType === constants.opTypes.otherShipment) searchModel.extraWhere = JobNames.OtherOP;
    
    let jobName = JobNames.Invoice;
    if(opType === constants.opTypes.warehousing) jobName = JobNames.WHInvoice;

    const apiResult = await api.getListItems( jobName,
      'InvoiceListItem',
      searchModel,
      1,
      search.pageSize,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0 };
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount };

  }

  renderCommands(): React.ReactNode {
    return (
      <InvoiceListCommands />
    );
  }

  renderBeforeConfigureButton(): React.ReactNode {
    return (
      <InvoiceListToolbar />
    );
  }



  renderExtras(hideLogHistory: boolean): React.ReactNode {
    return (
      <InvoiceListViewExtras hideLogHistory={hideLogHistory} />
    );
  }

  getViewUrlFor(row: InvoiceListItem) {
    if (!row.jobType && row.period !== "P") {
      return '';  // Not supported
    }

    if (!row.jobType && row.period === "P")
      return { url: row && row.id ? `/accounting/periodInvoice/view/${row.id}` : '', needAfterScreenUrl: true };
    else
      return { url: row && row.id ? `/accounting/invoice/view/${getJobNameFromInvBillCrDbJobType(row.jobType)}/${row.tbId}/${row.id}` : '', 
        needAfterScreenUrl: true, checkAllOperation: true };
  }

  getListViewTitle(opType: string | undefined) {
    return 'Invoice List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.Invoice} keyProp='id' />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  useLogHistory(): boolean {
    return true;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default InvoiceListView;
